import React from "react";
import { Box, Container, Typography, Divider, Link } from "@mui/material";

function TwilioVerifyPage() {
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Typography variant="h4" fontWeight={700}>
          TrustBud SMS Messaging Disclosure
        </Typography>

        <Typography color="text.secondary">
          This page is provided to support SMS verification and compliance
          review for TrustBud.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          What is TrustBud?
        </Typography>

        <Typography>
          TrustBud is an accountability product built to notice when users are
          starting to slip, nudge one small habit, and help them re-engage
          quickly. It combines personal habits with optional accountability
          through a real TrustBud relationship.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Why users receive text messages
        </Typography>

        <Typography>
          Users may receive SMS messages from TrustBud for the following reasons:
        </Typography>

        <ul>
          <li>Check-in and restart reminders</li>
          <li>Prompts tied to missed or at-risk activity</li>
          <li>Optional accountability notifications related to a TrustBud</li>
          <li>Account and system notifications relevant to active use</li>
        </ul>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Opt-in process
        </Typography>

        <Typography>
          Users explicitly opt in to receive SMS messages by providing their
          phone number during account registration and agreeing to receive
          accountability and system messages related to their activity.
        </Typography>

        <Typography color="text.secondary">
          SMS messages are not sent to users who have not provided consent.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Message frequency
        </Typography>

        <Typography>
          Message frequency varies based on user activity and preferences, but
          typically ranges from a few messages per week to more frequent prompts
          when a user is actively engaging with accountability features.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Opt-out and help
        </Typography>

        <Typography>
          Users can opt out of SMS messages at any time by replying:
        </Typography>

        <ul>
          <li>
            <strong>STOP</strong> — to unsubscribe from all SMS messages
          </li>
          <li>
            <strong>HELP</strong> — to receive support information
          </li>
        </ul>

        <Typography color="text.secondary">
          Standard message and data rates may apply.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Data usage and privacy
        </Typography>

        <Typography>
          Phone numbers are used solely for accountability messaging and system
          communication. TrustBud does not sell or share phone numbers with
          third parties for marketing purposes.
        </Typography>

        <Typography>
          For more information, please review our privacy practices or contact
          us directly.
        </Typography>

        <Divider />

        <Typography variant="h6" fontWeight={600}>
          Contact
        </Typography>

        <Typography>
          If you have questions about SMS messaging or account usage, you can
          reach us at:
        </Typography>

        <Typography>
          <Link href="mailto:support@trustbud.app">
            support@trustbud.app
          </Link>
        </Typography>

        <Divider />

        <Typography variant="caption" color="text.secondary">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>
    </Container>
  );
}

export default TwilioVerifyPage;
